import { SxProp } from '../../internal/styles/sx';
import { MoneyFormatterProps } from '../Money/types';

export const strikeThroughValues = ['none', 'default', 'negative'] as const;
type StrikeThrough = (typeof strikeThroughValues)[number];

export interface RawMoneyProps extends Omit<MoneyFormatterProps, 'styled'> {
  children: number | string;
  currency: string;
  strikeThrough?: StrikeThrough;
}

export interface StyledContainerProps extends SxProp {
  strikeThrough: StrikeThrough;
}
